export default __webpack_public_path__ + "static/media/service4.6d0ab401.png";